/**
 * Not used
 */
export default (kasko) => {
  kasko.addEventListener('route-changed', (changes) => {
    const inputState = kasko.getState().input;
    if (
      changes.current?.path.includes('summary') &&
      inputState.first_name === 'first_name' &&
      inputState.last_name === 'last_name'
    ) {
      kasko.dispatchEvent('set-state-input', {
        first_name: null,
        last_name: null,
      });
    }
  });
};
